var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "email-at-sign copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document-Delivery",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-Document-Delivery---not-paperless",
    transform: "translate(-658.000000, -294.000000)",
    stroke: "#898989"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email-at-sign-copy-3",
    transform: "translate(658.000000, 294.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,8.75 L23.5,11.5 L23.5,22 C23.5,22.828 22.828,23.5 22,23.5 L2,23.5 C1.172,23.5 0.5,22.828 0.5,22 L0.5,11.5 L4.5,8.75",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    points: "3.5 20.5 8.5 16.5 15.5 16.5 20.5 20.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5,11.5 L17.5,15.5",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,11.5 L6.5,15.5",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-9",
    points: "19.5 14.167 19.5 0.5 4.5 0.5 4.5 14.167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6.239 C12.973,6.239 13.761,7.027 13.761,8 C13.761,8.973 12.973,9.761 12,9.761 C11.027,9.761 10.239,8.973 10.239,8 C10.239,7.027 11.027,6.239 12,6.239 Z",
    id: "Stroke-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.543,11.718 C13.82,12.214 12.943,12.5 12,12.5 C9.515,12.5 7.5,10.485 7.5,8 C7.5,5.515 9.515,3.5 12,3.5 C14.485,3.5 16.5,5.515 16.5,8 L16.5,8.392 C16.5,9.148 15.887,9.761 15.131,9.761 C14.374,9.761 13.761,9.148 13.761,8.392 L13.761,8",
    id: "Stroke-13"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.de64f2b330c0c3b289004dec3555a5c1.svg";
export { ForwardRef as ReactComponent };